import React from 'react';
import PropTypes from 'prop-types';

import {Redirect} from 'components/ReactRouterDomLocalized';

import {getLoginPath} from 'utils/url';

function LoginRedirect({returnPath, location, cutHashBang = true}) {
    if (!returnPath && location) {
        returnPath = location.pathname + location.search;
    }

    returnPath = cutHashBang ? returnPath.replace(/^\/#/, '') : returnPath;

    return <Redirect to={getLoginPath(returnPath)}/>
}

LoginRedirect.propTypes = {
    returnPath: PropTypes.string,
    location: PropTypes.object,
    cutHashBang: PropTypes.bool
};

export default LoginRedirect;



// WEBPACK FOOTER //
// ./src/components/LoginRedirect.js